import React from 'react';

import { SVGIcon } from '../../wrappers/SVGIcon';
import CheckBox from '../../reusables/CheckBox';

import { getDateString } from '../../../helpers/utility';

import { IJobPostsListTableProps, IColumnProps } from '../../../interfaces/tables';
import { EmploymentType, IJobPostList } from '../../../interfaces/job_posts';

import { Icons } from '../../../data/Assets';
import { OPEmploymentTypes } from '../../../data/options';

const JobPostsListTable = (props: IJobPostsListTableProps) => {
    const { isLoading, jobPosts, selectedJobPosts, disableActions, onSelectJobPost, onEditJobPost, onCopyJobPost, onArchiveJobPost } = props;

    const actionItems = [
        {
            label: 'Copy',
            icon: Icons.DuplicateFill,
            onClick: (id: number) => onCopyJobPost(id)
        },
        {
            label: 'Edit',
            icon: Icons.EditFill,
            onClick: (id: number) => onEditJobPost(id)
        },
        {
            label: 'Archive',
            icon: Icons.Trash3Fill,
            onClick: (id: number) => onArchiveJobPost(id)
        }
    ]

    let columns: IColumnProps[] = [
        { name: "", sort: false, identifier: 'checkbox', buttonClass: 'btn_block' },
        { name: "Job Title", sort: true, identifier: 'job_title', buttonClass: 'btn_block' },
        { name: "Applicants", sort: false, identifier: 'applicants', buttonClass: 'btn_block' },
        { name: "Job Views", sort: false, identifier: 'job_views', buttonClass: 'btn_block' },
        { name: "Company", sort: false, identifier: 'company', buttonClass: 'btn_block' },
        { name: "Posted By", sort: false, identifier: 'posted_by', buttonClass: 'btn_block' },
        { name: "Job Type", sort: false, identifier: 'job_type', buttonClass: 'btn_block' },
        { name: "Creation Date", sort: false, identifier: 'creation_date', buttonClass: 'btn_block' },
        { name: "", sort: false, identifier: 'actions', buttonClass: 'btn_block' },
    ];

    if (disableActions) {
        columns = columns.filter(column => column.identifier !== 'actions' && column.identifier !== 'checkbox');
    }

    const handleSelectJobPost = (event: React.MouseEvent<HTMLButtonElement>, id: number) => {
        event.stopPropagation();
        onSelectJobPost(id);
    }

    const getJobType = (type: EmploymentType | null) => {
        if (!type) return '';
        return OPEmploymentTypes.find((option) => option.value === type)?.label || '';
    }

    const renderTable = () => {
        if (isLoading) {
            return (
                <tr>
                    <td colSpan={columns.length}>
                        <div className="display_flex flex_dir_column display_flex_center">
                            <span className="wt_600 pb_10">Loading</span>
                            <i className='immployer__list_loader' />
                        </div>
                    </td>
                </tr>
            );
        } else if (!jobPosts?.length) {
            return (
                <tr>
                    <td colSpan={columns.length} className='text_center'>
                        No records found.
                    </td>
                </tr>
            );
        } else {
            return jobPosts.map((jobPost, index) => renderJobPostRow(jobPost, index));
        }
    }

    const renderJobPostRow = (jobPost: IJobPostList, index: number) => {
        return (
            <tr
                key={index}
                onClick={() => onEditJobPost(jobPost.id)}
            >
                {!disableActions && (
                    <td>
                        <CheckBox checked={selectedJobPosts.includes(jobPost.id)} disabled={disableActions} onClick={(event, checked) => handleSelectJobPost(event, jobPost.id)} />
                    </td>
                )}
                <td>{jobPost.job_title}</td>
                <td>{jobPost.applicants}</td>
                <td>{jobPost.job_views}</td>
                <td>{jobPost.company}</td>
                <td>{jobPost.posted_by ?? '-'}</td>
                <td>{getJobType(jobPost.job_type)}</td>
                <td>{getDateString(jobPost.creation_date, "MMM DD-YYYY")}</td>
                {!disableActions && renderActionMenu(jobPost.id)}
            </tr>
        );
    }

    const renderActionMenu = (jobPostId: number) => {
        if (disableActions) return null;

        return (
            <td
                className="immployer__list_table__actions"
            >
                {actionItems.map((item, idx) => (
                    <button key={idx} onClick={(e) => { e.stopPropagation(); item.onClick(jobPostId) }}>
                        <SVGIcon src={item.icon} color='grey' hoverColor='dark_grey' />
                    </button>
                ))}
            </td>
        );
    }

    return (
        <div className="immployer__list_table__container">
            <table className="immployer__list_table">
                <thead>
                    <tr>
                        {columns.map((column, index) =>
                            <th key={index}>
                                <div>
                                    <button className={`${column.buttonClass ?? ''}`}>
                                        {column.name}
                                    </button>
                                </div>
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {renderTable()}
                </tbody>
            </table>
        </div>
    );
}

export default JobPostsListTable;